<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13">
    <slot />
    <g fill="none" :stroke="color">
      <path d="M.5 2.5c4.667 4 7.5 6 8.5 6s3.833-2 8.5-6" />
      <path
        d="M17.5 1.625v9.75c0 .308-.132.587-.341.789-.217.208-.516.336-.846.336H1.688c-.33 0-.63-.128-.847-.336-.21-.202-.341-.48-.341-.789v-9.75c0-.308.132-.587.341-.789C1.058.628 1.357.5 1.688.5h14.624c.33 0 .63.128.847.336.21.202.341.48.341.789z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
